import { render, staticRenderFns } from "./StatsAccountantRegistrationsModal.vue?vue&type=template&id=714bf1ec&"
import script from "./StatsAccountantRegistrationsModal.vue?vue&type=script&lang=js&"
export * from "./StatsAccountantRegistrationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports